module.exports = __webpack_public_path__ + "media/images/guide/anotacion/image7-0a2e121c3f190e321b5390e7b1073e5c.png";